import * as React from "react";
import { Context } from "./_context";
export const NavigationDiscoverIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.99 3.99a8.5 8.5 0 0 1 12.988 10.867l5.86 5.86c.1.1.149.15.167.206a.25.25 0 0 1 0 .155c-.018.057-.068.106-.167.205l-1.555 1.555c-.1.1-.148.149-.205.167a.25.25 0 0 1-.155 0c-.057-.018-.107-.068-.206-.167l-5.86-5.86A8.5 8.5 0 0 1 3.99 3.99Zm9.9 2.12a5.5 5.5 0 1 0-7.78 7.78 5.5 5.5 0 0 0 7.78-7.78Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationDiscoverIcon.iconId = "k5hMwl";
